var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, } from "@mui/material";
import { getNpsFormResponses, getNpsFormResponseServices, } from "../../apis/nps";
import { getApiErrorMessage } from "../../utils/forms.functions";
import { downloadCsv, generateCsv, mapResponseToCsvRow, } from "../../utils/csv.functions";
var ALL_SERVICES_VALUE = "Todas";
var NpsDownloadDialog = function (_a) {
    var open = _a.open, formId = _a.formId, formSlug = _a.formSlug, formTitle = _a.formTitle, accessToken = _a.accessToken, onClose = _a.onClose, onDownloadError = _a.onDownloadError;
    var _b = useState([]), services = _b[0], setServices = _b[1];
    var _c = useState(ALL_SERVICES_VALUE), selectedService = _c[0], setSelectedService = _c[1];
    var _d = useState(false), loadingServices = _d[0], setLoadingServices = _d[1];
    var _e = useState(false), downloading = _e[0], setDownloading = _e[1];
    var _f = useState(null), loadError = _f[0], setLoadError = _f[1];
    useEffect(function () {
        if (!open || !accessToken) {
            return;
        }
        var cancelled = false;
        setLoadingServices(true);
        setLoadError(null);
        setSelectedService(ALL_SERVICES_VALUE);
        getNpsFormResponseServices(formId, accessToken)
            .then(function (res) {
            if (cancelled)
                return;
            setServices(res.data);
        })
            .catch(function (err) {
            if (cancelled)
                return;
            setLoadError(getApiErrorMessage(err, "Não foi possível carregar os serviços disponíveis."));
            setServices([]);
        })
            .finally(function () {
            if (!cancelled)
                setLoadingServices(false);
        });
        return function () {
            cancelled = true;
        };
    }, [open, formId, accessToken]);
    var handleConfirmDownload = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var slugFilter, res, rows, csv, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDownloading(true);
                    onDownloadError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    slugFilter = selectedService === ALL_SERVICES_VALUE ? undefined : selectedService;
                    return [4 /*yield*/, getNpsFormResponses(formId, accessToken, slugFilter)];
                case 2:
                    res = _a.sent();
                    rows = res.data.map(mapResponseToCsvRow);
                    csv = generateCsv(rows);
                    downloadCsv(csv, "".concat(formSlug, "-respostas.csv"));
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    onDownloadError(getApiErrorMessage(err_1, "Não foi possível baixar as respostas."));
                    return [3 /*break*/, 5];
                case 4:
                    setDownloading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        accessToken,
        formId,
        formSlug,
        onClose,
        onDownloadError,
        selectedService,
    ]);
    var handleDialogClose = useCallback(function () {
        if (!downloading) {
            onClose();
        }
    }, [downloading, onClose]);
    var titleId = "nps-download-dialog-title";
    return (_jsxs(Dialog, __assign({ open: open, onClose: handleDialogClose, "aria-labelledby": titleId, fullWidth: true, maxWidth: "sm" }, { children: [_jsx(DialogTitle, __assign({ id: titleId }, { children: "Exportar respostas" })), _jsxs(DialogContent, { children: [formTitle && (_jsxs(Alert, __assign({ severity: "info", sx: { mb: 2 } }, { children: ["Formul\u00E1rio: ", _jsx("strong", { children: formTitle })] }))), _jsx("p", __assign({ style: { marginTop: 0 } }, { children: "Selecione quais respostas gostaria de trazer:" })), loadError && (_jsx(Alert, __assign({ severity: "error", sx: { mb: 2 } }, { children: loadError }))), _jsxs(FormControl, __assign({ fullWidth: true, disabled: loadingServices || !!loadError }, { children: [_jsx(InputLabel, __assign({ id: "nps-download-service-label" }, { children: "Respostas" })), _jsxs(Select, __assign({ labelId: "nps-download-service-label", id: "nps-download-service", value: selectedService, label: "Respostas", onChange: function (e) {
                                    setSelectedService(e.target.value);
                                } }, { children: [_jsx(MenuItem, __assign({ value: ALL_SERVICES_VALUE }, { children: "Todas" })), services.map(function (slug) { return (_jsx(MenuItem, __assign({ value: slug }, { children: slug }), slug)); })] }))] })), loadingServices && (_jsx(CircularProgress, { size: 24, sx: { display: "block", mt: 2 } }))] }), _jsxs(DialogActions, __assign({ sx: { px: 3, pb: 2 } }, { children: [_jsx(Button, __assign({ onClick: handleDialogClose, disabled: downloading, variant: "outlined", color: "error" }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: handleConfirmDownload, disabled: downloading || loadingServices || !!loadError, variant: "contained" }, { children: downloading ? (_jsx(CircularProgress, { size: 22, color: "inherit" })) : ("Baixar") }))] }))] })));
};
export default NpsDownloadDialog;
